'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('abstract-leveldown'),
    AbstractLevelDOWN = _require.AbstractLevelDOWN;

var inherits = require('inherits');

var DeferredIterator = require('./deferred-iterator');

var DeferredChainedBatch = require('./deferred-chained-batch');

var getCallback = require('./util').getCallback;

var deferrables = ['put', 'get', 'getMany', 'del', 'batch', 'clear'];
var optionalDeferrables = ['approximateSize', 'compactRange'];
var kInnerDb = Symbol('innerDb');
var kOperations = Symbol('operations');
var kPromise = Symbol('promise');

function DeferredLevelDOWN(db) {
  AbstractLevelDOWN.call(this, db.supports || {}); // TODO (future major): remove this fallback; db must have manifest that
  // declares approximateSize and compactRange in additionalMethods.

  var _iterator = _createForOfIteratorHelper(optionalDeferrables),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var m = _step.value;

      if (typeof db[m] === 'function' && !this.supports.additionalMethods[m]) {
        this.supports.additionalMethods[m] = true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  this[kInnerDb] = db;
  this[kOperations] = [];
  implement(this);
}

inherits(DeferredLevelDOWN, AbstractLevelDOWN);
DeferredLevelDOWN.prototype.type = 'deferred-leveldown'; // Backwards compatibility for reachdown and subleveldown

Object.defineProperty(DeferredLevelDOWN.prototype, '_db', {
  enumerable: true,
  get: function get() {
    return this[kInnerDb];
  }
});

DeferredLevelDOWN.prototype._open = function (options, callback) {
  var _this = this;

  var onopen = function onopen(err) {
    if (err || _this[kInnerDb].status !== 'open') {
      // TODO: reject scheduled operations
      return callback(err || new Error('Database is not open'));
    }

    var operations = _this[kOperations];
    _this[kOperations] = [];

    var _iterator2 = _createForOfIteratorHelper(operations),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var op = _step2.value;

        if (op.iterator) {
          op.iterator.setDb(_this[kInnerDb]);
        } else {
          var _this$kInnerDb;

          (_this$kInnerDb = _this[kInnerDb])[op.method].apply(_this$kInnerDb, _toConsumableArray(op.args));
        }
      }
      /* istanbul ignore if: assertion */

    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (_this[kOperations].length > 0) {
      throw new Error('Did not expect further operations');
    }

    callback();
  };

  if (this[kInnerDb].status === 'new' || this[kInnerDb].status === 'closed') {
    this[kInnerDb].open(options, onopen);
  } else {
    this._nextTick(onopen);
  }
};

DeferredLevelDOWN.prototype._close = function (callback) {
  this[kInnerDb].close(callback);
};

DeferredLevelDOWN.prototype._isOperational = function () {
  return this.status === 'opening';
};

function implement(self) {
  var additionalMethods = Object.keys(self.supports.additionalMethods);

  var _iterator3 = _createForOfIteratorHelper(deferrables.concat(additionalMethods)),
      _step3;

  try {
    var _loop = function _loop() {
      var method = _step3.value;

      // Override the public rather than private methods to cover cases where abstract-leveldown
      // has a fast-path like on db.batch([]) which bypasses _batch() because the array is empty.
      self[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (method === 'batch' && args.length === 0) {
          return new DeferredChainedBatch(this);
        } else if (this.status === 'open') {
          var _this$kInnerDb2;

          return (_this$kInnerDb2 = this[kInnerDb])[method].apply(_this$kInnerDb2, args);
        }

        var callback = getCallback(args, kPromise);

        if (this.status === 'opening') {
          this[kOperations].push({
            method: method,
            args: args
          });
        } else {
          this._nextTick(callback, new Error('Database is not open'));
        }

        return callback[kPromise];
      };
    };

    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  self.iterator = function (options) {
    if (this.status === 'open') {
      return this[kInnerDb].iterator(options);
    } else if (this.status === 'opening') {
      var iterator = new DeferredIterator(this, options);
      this[kOperations].push({
        iterator: iterator
      });
      return iterator;
    } else {
      throw new Error('Database is not open');
    }
  };

  var _iterator4 = _createForOfIteratorHelper(deferrables.concat(['iterator'])),
      _step4;

  try {
    var _loop2 = function _loop2() {
      var method = _step4.value;

      self['_' + method] = function () {
        /* istanbul ignore next: assertion */
        throw new Error('Did not expect private method to be called: ' + method);
      };
    };

    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}

module.exports = DeferredLevelDOWN;
module.exports.DeferredIterator = DeferredIterator;